import React from 'react';
import { Box } from '@mui/material';
import { ViewMode } from './urlState';
import { MODES } from './modes';

interface Props {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const ModeSwitcher: React.FC<Props> = ({ value, onChange }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mb: 3,
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 999,
          p: 0.5,
          gap: 0.375,
          flexWrap: 'wrap',
        }}
      >
        {MODES.map((m) => {
          const on = m.key === value;
          return (
            <Box
              key={m.key}
              component="button"
              onClick={() => onChange(m.key)}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                height: 44,
                px: 2.5,
                cursor: 'pointer',
                border: 'none',
                borderRadius: 999,
                fontFamily: 'inherit',
                fontSize: 15,
                fontWeight: 700,
                bgcolor: on ? 'primary.main' : 'transparent',
                color: on ? '#fff' : 'text.secondary',
                transition: 'all .15s ease',
                '&:hover': {
                  color: on ? '#fff' : 'text.primary',
                },
              }}
            >
              {m.label}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ModeSwitcher;
